import { useState, useEffect, useCallback, useRef } from "react";
import { useAuth } from "../contexts/AuthContext";
import { getDonorPartnerships } from "../api/partnershipsApi";

const RECENTLY_CLAIMED_HOURS = 48;

export const usePartnershipBadge = () => {
  const { user } = useAuth();
  const [claimedCount, setClaimedCount] = useState(0);
  const isFetching = useRef(false);

  const isDonor = user?.can_donate || user?.is_master_admin || user?.is_company_admin;

  const fetch = useCallback(async () => {
    if (!isDonor || isFetching.current) return;
    isFetching.current = true;

    try {
      const res = await getDonorPartnerships();
      const now = Date.now();
      const cutoff = RECENTLY_CLAIMED_HOURS * 60 * 60 * 1000;

      const count = (res?.partnerships || []).filter((p) => {
        if (p.status !== "active" || !p.claimed_at) return false;
        return now - new Date(p.claimed_at).getTime() < cutoff;
      }).length;

      setClaimedCount(count);
    } catch {
      // silent — badge is non-critical
    } finally {
      isFetching.current = false;
    }
  }, [isDonor]);

  useEffect(() => {
    if (user) fetch();
  }, [user, fetch]);

  return { claimedCount };
};
